import { useQuery } from "@tanstack/react-query";

import type { RollingSummaryResult } from "../../models/RollingSummary";
import { getRollingSummary } from "../../repositories/RollingSummaryRepository";

interface UseRollingSummaryQueryProps {
	assetId: number;
	sectionId: number | null;
	enabled?: boolean;
	onError?: (error: Error) => void;
}

export const useRollingSummaryQuery = ({
	assetId,
	sectionId,
	enabled = true,
	onError,
}: UseRollingSummaryQueryProps) =>
	useQuery<RollingSummaryResult, Error>({
		queryKey: ["test-shack-rolling-summary", assetId, sectionId],
		meta: { realtime: ["DIM.GetRollingSummary"] },
		queryFn: ({ signal }) =>
			getRollingSummary(
				{
					assetId,
					sectionId: sectionId as number,
				},
				signal,
			),
		enabled: enabled && sectionId !== null,
		onError,
	});
